module.exports = __webpack_public_path__ + "img/arrow-left.da35679d.svg";